<!-- 
	Login
	props: N/A
  role: Public
	Called by @/views/Auth to login users
-->

<template>
	<div class="login py-4 text-white">
		<div v-if="error" class="alert -mt-4">
			<Alert>{{ error }}</Alert>
		</div>
		<form autocomplete="on" @submit.prevent="login">
			<div class="form-group">
				<input
					v-model="form.employeeId"
					type="text"
					onkeypress='return event.charCode >= 48 && event.charCode <= 57'
					placeholder="Employee ID"
					autocomplete="off"
					maxlength="8"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.email"
					type="email"
					placeholder="Email"
					autocomplete="email"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.password"
					type="password"
					placeholder="Password"
					autocomplete="current-password"
					required
				/>
			</div>
			<CustomButton id="cb-gold">Log In</CustomButton><br />
			<router-link to="/reset" class="winwin-gold2 font-bold"
				>Forgot Password</router-link
			>
		</form>
	</div>
</template>

<script>
	import firebase from "firebase";

	import Alert from "@/components/Alert";
	import CustomButton from "@/components/CustomButton";

	export default {
		name: "Login",
		components: {
			CustomButton,
			Alert,
		},
		data() {
			return {
				form: {
					employeeId: "",
					email: "",
					password: "",
				},
				error: null,
			};
		},
		methods: {
			login() {
				// user action triggers firebase login
				firebase
					.auth()
					.signInWithEmailAndPassword(this.form.email, this.form.password)
					.then((data) => {
						if (data.user.emailVerified === true) {
							// if email is verified with firebase continue
							const ref = firebase
								.firestore()
								.collection("users")
								.doc(this.form.employeeId);

							ref.get().then((doc) => {
								if (doc.exists) {
									data.user.additionalData = doc.data();

									this.$store.commit("SET_ADD_DATA", data.user.additionalData);
								} else {
									alert("No account is associated with this ID. Please use the Employee ID used at registration.");
								}
							});

							this.$store.dispatch("fetchUser", data.user);
							this.$router.replace({ name: "User" });
						} else {
							// if email is not verified with firebase do not allow login regardless if credentials are confirmed
							firebase
								.auth()
								.signOut()
								.then(() => {
									this.$store.dispatch("fetchUser", null);

									this.$store.dispatch(
										"setError",
										"Please verify your email before logging in."
									);
									this.$router.replace({
										name: "Auth",
									});
								});
						}
					})
					.catch((err) => {
						// throw any errors to alert
						this.error = err.message;
					});
			},
		},
	};
</script>

<style scoped>
	.form-group {
		margin: 12.5px 0;
	}

	form .form-group input {
		border-bottom: 1px solid #ffffff;
		width: 270px;
		padding: 1px 3px 5px;
		background-color: transparent;
		color: #ffffff;
	}
</style>
